import React, { useEffect } from 'react';

const Loading = () => {
  useEffect(() => {

    document.body.style.overflow = 'hidden';


    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="fixed inset-0 flex justify-center items-center z-10">
      <div className="bg-black bg-opacity-80 absolute inset-0 flex justify-center items-center">
        <p className="font-bebas text-5xl text-light z-20">Loading ...</p>
      </div>
    </div>
  );
};

export default Loading;
